<template>
    <div>
        <!--
        <div><i class="material-icons">textsms</i></div>
        <h3>SMS-påminnelse kunde:</h3>

        <div>
            <textarea placeholder="Sms text" v-model="sms_text" rows="6"></textarea>
            <span class="v-error" v-if="localErrors.sms_text" v-text="localErrors.sms_text"></span>
        </div>
        <div>
            <input @keyup.enter="send()" v-model="phone_number" placeholder="Phone number (12345678)" type="text"/>
            <span class="v-error" v-if="localErrors.phone_number" v-text="localErrors.phone_number"></span>
        </div>
        <div>
            <button @click.prevent="send()">Send</button>
        </div>
        -->

        <div v-if="company_slug == 'klp'">
            <div><i class="material-icons">sentiment_very_satisfied</i></div>
            <div v-if="view=='main'">
                <h3>Ble bilen reparert? </h3>
                <div class="fd-status-wrap">
                    <div class="input-wrap">
                        <input type="radio" id="finish_status-positive" v-model="finish_status" value="-1">
                        <label for="finish_status-positive">Nei</label>
                    </div>
                    <div class="input-wrap">
                        <input type="radio" id="finish_status-negative" v-model="finish_status" value="1">
                        <label for="finish_status-negative">Ja</label>
                    </div>
                    <span class="v-error" v-if="localErrors.finish_status" v-text="localErrors.finish_status"></span>
                </div>
                <div v-if="finish_status">
                    <button v-if="finish_status < 0" @click.prevent="send()">Send</button>
                    <button v-if="finish_status > 0" @click.prevent="view='form'">Neste</button>
                </div>
            </div>
            <div v-if="view=='form'">
                <h3>Ble det brukt forsikring?</h3>
                <div class="fd-status-wrap">
                    <div class="input-wrap">
                        <input type="radio" id="insurance-status-positive" v-model="insurance_status" value="-1">
                        <label for="insurance-status-positive">Nei</label>
                    </div>
                    <div class="input-wrap">
                        <input type="radio" id="insurance-status-negative" v-model="insurance_status" value="1">
                        <label for="insurance-status-negative">Ja</label>
                    </div>
                </div>
                <div v-if="localErrors.insurance_status">
                    <span class="v-error" v-text="localErrors.insurance_status"></span>
                </div>
                <div class="input-wrap">
                    <input v-model="finish_price" type="text" placeholder="Pris"/>
                    <span class="v-error" v-if="localErrors.finish_price" v-text="localErrors.finish_price"></span>
                </div>
                <div v-if="insurance_status>0" class="input-wrap">
                    <input v-model="finish_damage_numbers" type="text" placeholder="Skadenummer"/>
                    <span class="v-error" v-if="localErrors.finish_damage_numbers" v-text="localErrors.finish_damage_numbers"></span>
                </div>
                <div>
                    <button @click.prevent="send()">Send inn</button>
                </div>
            </div>
        </div>
        <div v-else>
            <p>Dette merker tilbudet som ferdig reparert og sender mail til oppdragsgiver</p>
            <div class="actions">
                <button @click.prevent="close()">Avbryt</button>
                <button @click.prevent="send()">Send</button>
            </div>
        </div>
    </div>
</template>

<script>

import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

export default {
  data () {
    return {
        view: 'main',
        company_slug: null,
        finish_status: null,
        insurance_status: null,
        finish_damage_numbers: null,
        finish_price: null,
        id_request: null,
        validate: false
    }
  },
  mixins: [VuejsDialogMixin],
  computed: {
      localErrors(){
          if(this.validate){
              var e = {};
              if(!this.finish_status) {
                  e.finish_status = 'Field is required';
              }else{
                  if(!this.insurance_status)
                      e.insurance_status = 'Field is required';
                  if(parseFloat(this.finish_status) > 0 && !parseFloat(this.finish_price))
                      e.finish_price = 'Field is required';
                  if(parseFloat(this.insurance_status) > 0 && !this.finish_damage_numbers)
                      e.finish_damage_numbers = 'Field is required';
              }
              return e;
          }else{
              return {};
          }
      }
  },
  methods: {
      send(){
        this.validate = true;
        if(this.company_slug == 'klp' && !this.validateData()) return;
        this.proceed({
            finish_status: this.finish_status,
            finish_damage_numbers: this.insurance_status > 0 ? this.finish_damage_numbers : null,
            finish_price: this.finish_status > 0 ? this.finish_price : null,
            id_request: this.id_request
        });
      },
      validateData(){
          this.validate = true;

          if(Object.keys(this.localErrors).length)
              return false;

          return true;
      },
  },
  created(){
      if(this.messageBody) {
          let data = JSON.parse(this.messageBody);
          this.company_slug = data.company_slug
          this.finish_status = data.finish_status
          this.finish_damage_numbers = data.finish_damage_numbers
          this.finish_price = data.finish_price
          this.id_request = data.id_request
      }
  }
}
</script>

<style lang="scss">
    .v-error{
        color: red;
        text-align: right;
        font-size: 12px;
    }
    .fd-status-wrap{
        display: flex;
        justify-content: space-evenly;
    }
</style>


// WEBPACK FOOTER //
// FinishDialog.vue?780aefc9